import { accessToken } from "../components/core/auth-service/auth-service";
import {
  FETCH_DUE_PAYMENTS_BEGIN,
  FETCH_DUE_PAYMENTS_SUCCESS,
  FETCH_DUE_PAYMENTS_FAILURE
} from "./actionTypes";

import getConfig from "../environment";
import {GetDuePaymentsRequest} from "../model/GetDuePaymentsRequest";
import {ErrorResponseWrapper} from "../model/ErrorResponseWrapper";


export const fetchDuePaymentsBegin = request => ({
  type: FETCH_DUE_PAYMENTS_BEGIN,
  payload: request
});

export const fetchDuePaymentsSuccess = (duePaymentsResponse) => ({
  type: FETCH_DUE_PAYMENTS_SUCCESS,
  payload: {duePaymentsResponse}
});

export const fetchDuePaymentsFailure = errors => ({
  type: FETCH_DUE_PAYMENTS_FAILURE,
  payload: {errors}
});

const DUE_PAYMENTS_API = getConfig()?.duePaymentsApi;
/*const DUE_PAYMENTS_API = "http://localhost:3000/financials/due-payments";*/
export async function getDuePayments(dispatch:any,request: GetDuePaymentsRequest, baseSiteUID:string, salesAreaDependantCustomerUid:string, currentLanguage:string) {
  const url = `${DUE_PAYMENTS_API}${request.toQueryString()}`;
  dispatch(fetchDuePaymentsBegin(request));
  return fetch(url, {
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'PT-Base-Site-UID': `${baseSiteUID}`,
      'PT-Sales-Area-Dependent-Customer-Uid': `${salesAreaDependantCustomerUid}`,
      'Accept-language': currentLanguage,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(res => {
    if (!res.ok) {
      throw new ErrorResponseWrapper(res);
    } else {
      return res.json();
    }
  })
  .then(data => {
    dispatch(fetchDuePaymentsSuccess(data.installments));
    return {duePayments:data.installments};
  })
  .catch((errorResponse: ErrorResponseWrapper) => {
/*
      errorResponse.getErrorMessages().then((messages) => {
        dispatch(fetchDuePaymentsFailure(messages));
*/
    dispatch(fetchDuePaymentsFailure(errorResponse))
  })
}

const FINANCIALS_BASE_URL = getConfig().creditLimitApi;
export async function getBankSlip(paymentData:any, baseSiteUID:string, salesAreaDependantCustomerUid:string, currentLanguage:string) {

  return fetch(`${FINANCIALS_BASE_URL}/bank-slip`, {
    method: "POST",
    body: JSON.stringify(paymentData),
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'PT-Base-Site-UID': `${baseSiteUID}`,
      'PT-Sales-Area-Dependent-Customer-Uid': `${salesAreaDependantCustomerUid}`,
      'Accept-language': currentLanguage,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(res => {
      if (!res.ok) {
        throw new Error()
      }
      return res.json()
    })
    .then(data => {
      return data.html
    })
}
